import React from "react";
import SelectInput from './SelectInput';

import Button from './Button';
import TextInput from './TextInput';

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import './css/editor.css';
import MyDatePicker from "./DatePickerIta";
import moment from 'moment';
import translateString from "../utils/Locales";
import Utils from "../utils/utils";

let t = translateString;

export default class AddRataWidget extends React.Component {

    constructor(props){
        super(props);

        this.rataDateRef = React.createRef();

        this.options = [];
        this.options.push({ value: 'NON PAGATA', label: t('non_pagata_s')});
        this.options.push({ value: 'DA VERIFICARE', label: t('DA VERIFICARE')});
        this.options.push({ value: 'PAGATA', label: t('PAGATA')});

        this.state = {
            importo: '',
            option: { value: 'NON PAGATA', label: t('non_pagata_s')}
        }
    }

    onContentStateChange = contentState => {

        this.savedEnabled = true;
        this.setState({ contentState});
       }

    render (){

        const that = this;
        return ( 

        <div style={{display: this.props.show == true ? 'block' : 'none'}}> 
            <div style={container} onClick={() => { this.setState({visible: false}); this.props.onClose(); }}>
            <div style={mainClass} onClick={(e) => e.stopPropagation()}>
                
            <div style={closeIcon} onClick={() => {
                this.setState({visible: false});
                this.props.onClose();
            }}>
                <img alt="" src={ require('../images/close_icon.png')} style={{ width: 30, height: 30, cursor: 'pointer' }} />
            </div>
            <div style={windowTitle}>{t('aggiungi_rata')}</div>
                <div style={{ display: 'flex', marginLeft: 5, marginBottom: 0, marginTop: -5 }}>
                    <img alt="" src={ require('../images/question_icon.png') } style={{ width: 10, height: 10, marginRight: 5, marginTop: 10 }} />
                    <p style={{ fontSize: 10, color: 'darkgray', maxWidth: '80%' }}>{t('rata_info_1')}<br/>{t('rata_info_2')}</p><br/>
                </div><br/>
                <div style={{marginLeft: '5px'}}>{t('data')}:</div>
                <MyDatePicker ref={this.rataDateRef} />
                <TextInput name={t('importo') + ":"} value={this.state.importo} onChange={(text) => {this.setState({importo: text})}} />
                {this.props.isStudent && 
                    <SelectInput key={Math.random()} 
                        value={this.state.option} 
                        name={t('stato') + ":"} 
                        options={this.options}
                        isMulti={false}
                        onChange={(option) => {
                            this.setState({
                                option: option
                            });
                        }}
                    />
                }
                <br/>
                <br/>

                <Button callback={() => {
                        
                    var status = this.state.option.value;

                    const rataDate = this.rataDateRef.current.getDate();
                    let strRataDate = moment(rataDate).format('DD-MM-yyyy');

                    if (strRataDate == 'Invalid date') return;
                    if (this.state.importo == '') return;
                    console.log(this.state.importo);
                    if (this.state.importo.replace(/,/g, '.').includes('.')) {
                        Utils.showError(t('errore_costo_int'));
                        return;
                    }
                    var importo = parseFloat(this.state.importo);
                    if (isNaN(importo)) return;

                    this.props.onFinish(strRataDate, this.state.importo, status);
                }} title={t('invia').toUpperCase()}></Button>
            </div>
            </div>
        </div>
        )
    }


}

const closeIcon = {
    position: 'absolute', 
    cursor: 'pointer',
    right: 10, 
    top: 10, 
    padding: 10, 
    zIndex: 999,
}

const container = {
    position: 'fixed', 
    display: 'block', 
    top: 0,
    left: 0, 
    bottom: 0, 
    right: 0,
    minWidth: '100%', 
    minHeight: '100%', 
    backgroundColor: '#3C3C3C4D',
    overflowY: 'scroll',
    overflowX: 'hidden',
};

const mainClass = {
    position: 'absolute',
    left: 'calc((100% - 350px)/2',
    top: '100px',
    right: '35%',
    minWidth: '350px',
    width: '350px',
    background: 'white',
    padding: '20px',
    zIndex: 2000,
    boxShadow: '0px 2px 10px darkgrey', 
    borderRadius: '10px',
}

const windowTitle = {
    color: 'darkgrey', 
    fontSize: 30, 
    fontWeight: 'bold', 
    fontFamily: 'Teko', 
    textAlign:'left', 
    marginLeft: 5, 
}